<template>
  <div class="goods_add">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="分类名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>

      <el-form-item label="上级" prop="cate" :value-key="0">
          <el-cascader
                  :value="default_options"
                  ref="cascader"
                  @change="change"
                  :options="cate_option"
                  :props="{checkStrictly: true }"
                  clearable></el-cascader>

      </el-form-item>

      <div class="mt-20"></div>

      <el-form-item class="quill-editor-top">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-if="edit_flag == false"
          >立即创建</el-button
        >
        <el-button type="primary" @click="submitForm('ruleForm')" v-else>编辑</el-button>

        <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
      </el-form-item>
    </el-form>
    <el-card>

        <div v-for="(item,index) in category.data" :key="index">
            <el-card>

                <div style="padding: 5px">

                    {{item.label}}
                    <el-button
                            @click.native="edit(item.id,item.label,item.value)"
                            type="primary"
                            size="small"
                    >编辑</el-button
                    >
                    <el-button @click.native="cate_del(item.id, 0)" type="primary" size="small"
                    >删除</el-button
                    >
                </div>




            <div v-for="(item1,index1) in item.children" :key="index1">


                 <div style="padding: 5px;padding-left: 20px;">
                     {{item1.label}}


                     <el-button
                             @click.native="edit(item1.id,item1.label,item.value)"
                             type="primary"
                             size="small"
                     >编辑</el-button >
                     <el-button @click.native="cate_del(item1.id, 0)" type="primary" size="small"
                     >删除</el-button
                     >
                 </div>







                    <div v-for="(item2,index2) in item1.children" :key="index2" style="padding: 5px;padding-left: 50px;">
                        {{item2.label}}

                        <el-button
                                @click.native="edit(item2.id,item2.label,item.value+','+item1.value)"
                                type="primary"
                                size="small"
                        >编辑</el-button >
                        <el-button @click.native="cate_del(item2.id, 0)" type="primary" size="small"
                        >删除</el-button
                        >

                    </div>





            </div>
            </el-card>
        </div>

    </el-card>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      default_options:[],

      edit_flag: false,
      id: 0,
      cate_option:[],
      ruleForm: {
        name: "",

        cate: "",
      },
      dialogVisible: false,

      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      category: (state) => state.category.result,
    }),
  },
  methods: {
    ...mapActions({
      getCategoryDataAction: "getCategoryDataAction",
      addCategoryDataAction: "addCategoryDataAction",
      editCategoryDataAction: "editCategoryDataAction",
      delCategoryDataAction: "delCategoryDataAction",
    }),
      change(val) {
          console.log(val);






          let len=val.length

          let node_cate=0
          if(len>0){
              let node= val[len-1]

              let node_item=node.split("_")
              if(node_item.length>0){
                  node_cate=node_item[node_item.length-1]

              }



          }else{
              node_cate=0
          }
          console.log("id",this.id)
          // if(nodes.length>0){
          //
          //     alert(nodes[len-1])
          // }

          // let node=0
          // if(len>0){
          //     node=val[len-1].toString()
          // }

          // this.area_content=[]
          // let nodes=this.$refs.cascader.getCheckedNodes()
          // console.log(nodes)
          // for (let i=0;i<nodes.length; i++){
          //     this.area_content[i]=nodes[i]['pathLabels']
          //     console.log(nodes[i]['pathLabels'])
          // }
          // console.log(this.area_content);

          this.ruleForm.cate =node_cate;
      },
    edit(id,name ,attr) {
      let node=attr.split(",")


      this.id = id;
      this.ruleForm.name = name;
      this.ruleForm.cate = node[node.length-1]

      this.default_options=node

      this.edit_flag = true;
    },
    cate_del(id, type) {
      this.id = id;

      this.delCategoryDataAction({
        id: this.id,

        type: type,
      });
      console.log(type);
    },
      IterationDelateMenuChildren(arr) {
          if (arr.length > 0) {
              for (let i in arr) {
                  if (arr[i].children.length) {
                      this.IterationDelateMenuChildren(arr[i].children);
                  } else {
                      arr[i].children = undefined;
                  }
              }
          }
          return arr;
      },
    saveData() {


      if (this.edit_flag) {
        this.editCategoryDataAction({
          id: this.id,
          cate: this.ruleForm.cate,
          name: this.ruleForm.name,
        });
        this.id=0;
        this.default_options=[]
      } else {
        this.addCategoryDataAction({
          cate: this.ruleForm.cate,
          name: this.ruleForm.name,
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  created() {
    this.getCategoryDataAction({});
  },
  watch: {
    category(newdata, olddata) {
      if (newdata.code == 400) {
        this.$message("属性已经存在");
        this.getCategoryDataAction({});
      }
      // if (newdata.code == 200) {
      //   this.$refs["ruleForm"].resetFields();
      //   this.getAttrNameDataAction({});
      // }
      if (newdata.code == 301) {

          this.$message({
              message: '类别添加成功',
              type: 'success'
          });
        this.getCategoryDataAction({});
      }
      if (newdata.code == 302) {

          this.$message({
              message: '类别更新成功',
              type: 'success'
          });
        this.ruleForm.name = "";
        this.ruleForm.cate = "";
        this.id = 0;
        this.edit_flag = false;
        this.getCategoryDataAction({});
      }
      if (newdata.code == 303) {
        this.$message("类别删除成功");
        this.ruleForm.name = "";
        this.ruleForm.cate = "";
        this.id = 0;

        this.getCategoryDataAction({});
      }
      if (newdata.code == 304) {
        this.$message("请选择删除下级类别");
        this.ruleForm.name = "";
        this.ruleForm.cate = "";
        this.id = 0;

        this.getCategoryDataAction({});
      }
      if(newdata.code==200){

       this.cate_option=  this.IterationDelateMenuChildren( newdata.data)
      }
      console.log(newdata, olddata);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.quill-editor {
  height: 400px;
}

.quill-editor-bottom {
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
</style>
